var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "qr-code",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15059",
    "data-name": "Grupo 15059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14478",
    "data-name": "Caminho 14478",
    d: "M.818,6.545A.773.773,0,0,1,0,5.727V2.455A2.411,2.411,0,0,1,2.455,0H5.727a.773.773,0,0,1,.818.818.773.773,0,0,1-.818.818H2.455a.773.773,0,0,0-.818.818V5.727a.773.773,0,0,1-.818.818Z",
    fill: "#1c787e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15060",
    "data-name": "Grupo 15060",
    transform: "translate(11.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14479",
    "data-name": "Caminho 14479",
    d: "M350.711,6.545a.773.773,0,0,1-.818-.818V2.455a.773.773,0,0,0-.818-.818H345.8a.773.773,0,0,1-.818-.818A.773.773,0,0,1,345.8,0h3.273a2.411,2.411,0,0,1,2.455,2.455V5.727A.773.773,0,0,1,350.711,6.545Z",
    transform: "translate(-344.984 0)",
    fill: "#1c787e"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15061",
    "data-name": "Grupo 15061",
    transform: "translate(0 11.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14480",
    "data-name": "Caminho 14480",
    d: "M5.727,351.53H2.455A2.411,2.411,0,0,1,0,349.076V345.8a.773.773,0,0,1,.818-.818.773.773,0,0,1,.818.818v3.273a.773.773,0,0,0,.818.818H5.727a.818.818,0,1,1,0,1.636Z",
    transform: "translate(0 -344.985)",
    fill: "#1c787e"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15062",
    "data-name": "Grupo 15062",
    transform: "translate(11.454 11.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14481",
    "data-name": "Caminho 14481",
    d: "M349.076,351.529H345.8a.818.818,0,0,1,0-1.636h3.273a.773.773,0,0,0,.818-.818V345.8a.818.818,0,0,1,1.636,0v3.273A2.411,2.411,0,0,1,349.076,351.529Z",
    transform: "translate(-344.985 -344.984)",
    fill: "#1c787e"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15063",
    "data-name": "Grupo 15063",
    transform: "translate(3.272 3.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14482",
    "data-name": "Caminho 14482",
    d: "M102.658,103.476H99.385a.773.773,0,0,1-.818-.818V99.385a.773.773,0,0,1,.818-.818h3.273a.773.773,0,0,1,.818.818v3.273A.773.773,0,0,1,102.658,103.476ZM100.2,101.84h1.636V100.2H100.2Z",
    transform: "translate(-98.567 -98.567)",
    fill: "#1c787e"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15064",
    "data-name": "Grupo 15064",
    transform: "translate(3.272 9.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14483",
    "data-name": "Caminho 14483",
    d: "M102.658,300.61H99.385a.773.773,0,0,1-.818-.818v-3.273a.773.773,0,0,1,.818-.818h3.273a.773.773,0,0,1,.818.818v3.273A.773.773,0,0,1,102.658,300.61Zm-2.455-1.636h1.636v-1.636H100.2Z",
    transform: "translate(-98.567 -295.701)",
    fill: "#1c787e"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15065",
    "data-name": "Grupo 15065",
    transform: "translate(9.818 3.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14484",
    "data-name": "Caminho 14484",
    d: "M299.792,103.476h-3.273a.773.773,0,0,1-.818-.818V99.385a.773.773,0,0,1,.818-.818h3.273a.773.773,0,0,1,.818.818v3.273A.773.773,0,0,1,299.792,103.476Zm-2.455-1.636h1.636V100.2h-1.636Z",
    transform: "translate(-295.701 -98.567)",
    fill: "#1c787e"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15066",
    "data-name": "Grupo 15066",
    transform: "translate(9.818 9.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14485",
    "data-name": "Caminho 14485",
    d: "M296.519,298.155a.773.773,0,0,1-.818-.818v-.818a.818.818,0,0,1,1.636,0v.818A.773.773,0,0,1,296.519,298.155Z",
    transform: "translate(-295.701 -295.7)",
    fill: "#1c787e"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15067",
    "data-name": "Grupo 15067",
    transform: "translate(12.272 9.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14486",
    "data-name": "Caminho 14486",
    d: "M371.262,297.337h-.818a.818.818,0,0,1,0-1.636h.818a.818.818,0,0,1,0,1.636Z",
    transform: "translate(-369.626 -295.701)",
    fill: "#1c787e"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15068",
    "data-name": "Grupo 15068",
    transform: "translate(10.637 13.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14487",
    "data-name": "Caminho 14487",
    d: "M323.616,395.9h-2.455a.818.818,0,1,1,0-1.636h2.455a.818.818,0,0,1,0,1.636Z",
    transform: "translate(-320.343 -394.268)",
    fill: "#1c787e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.5e9f2002feef7691074ea68f866fdcb3.svg";
export { ForwardRef as ReactComponent };